const Star = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10.3671 15.0911C10.1392 14.9634 9.86141 14.9634 9.63359 15.0911L6.01193 17.1213C5.45357 17.4343 4.78497 16.949 4.90953 16.3211L5.72345 12.2183C5.77167 11.9752 5.69671 11.724 5.52317 11.5471L2.72484 8.69463C2.29068 8.25207 2.55045 7.50377 3.16545 7.42542L6.99193 6.93795C7.2485 6.90526 7.47013 6.74268 7.57835 6.50776L9.31913 2.72878C9.58704 2.14717 10.4136 2.14717 10.6815 2.72878L12.4223 6.50776C12.5305 6.74268 12.7521 6.90526 13.0087 6.93795L16.8352 7.42542C17.4502 7.50377 17.71 8.25207 17.2758 8.69463L14.4775 11.5471C14.3039 11.724 14.229 11.9752 14.2772 12.2183L15.0911 16.3211C15.2157 16.949 14.5471 17.4343 13.9887 17.1213L10.3671 15.0911Z"
        fill={color}
      />
    </svg>
  )
}

export default Star
